import { render, staticRenderFns } from "./Fichaje.vue?vue&type=template&id=bcb63364&scoped=true"
import script from "./Fichaje.vue?vue&type=script&lang=js"
export * from "./Fichaje.vue?vue&type=script&lang=js"
import style0 from "./Fichaje.vue?vue&type=style&index=0&id=bcb63364&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb63364",
  null
  
)

export default component.exports